module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "f-nav-flex"
  }, [_c('ul', {
    staticClass: "list-wrap"
  }, _vm._l((_vm.listItem), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "list",
      class: {
        'active': item.active
      },
      attrs: {
        "data-type": item.type,
        "data-id": item.id
      },
      on: {
        "click": _vm.onClickHandle
      }
    }, [_c('span', [_vm._v(_vm._s(item.text))])])
  }), 0)])
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-bf732bfa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-bf732bfa!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/nav/nav-flex.vue
// module id = 14
// module chunks = 0